import { Button, Col, Flex, Form, Input, Modal, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { FormInput } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";

function RejectReasonModal({
    isModalOpen = false,
    onSubmit = () => { },
    action = "",
    onRejectModalClose = () => { }
}) {
    const { t, i18n } = useTranslation();
    console.log("reject modal");


    const [form] = useForm();
    const formItemLayout = {
        labelCol: { span: 8 }, // Adjust the span as needed
    };


    return (
        <Modal
            width="25vw"
            // height="20vh"
            footer={() => {
                return (
                    <Row justify='end'>
                        <Space direction="horizontal" size="middle">
                            <Button
                                onClick={() => {
                                    onRejectModalClose()
                                    form.resetFields();
                                }}
                                type="default"
                                style={{ height: "40px", borderRadius: "8px" }}
                            >
                                {t("common.cancel")}
                            </Button>
                            <Button
                                onClick={() => {
                                    form.submit();
                                }}
                                type="primary"
                                style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}
                            >
                                {t("common.submit")}
                            </Button>
                        </Space>
                    </Row >
                )
            }
            }
            title={t("payroll.label.reject_reason")}
            onCancel={() => {
                form.resetFields()
                onRejectModalClose()
            }}
            destroyOnClose
            open={isModalOpen}
            onOk={(e) => {
                form.submit()
                onSubmit(e)
            }}
            closable={false}
            maskClosable={false}
        >
            <FormAntd
                {...formItemLayout}
                colon={false}
                form={form}
                onFinish={(val) => {
                    console.log("reason is ", val);

                    onSubmit(val)
                }}
                initialValues={{}}

                requiredMark={(label, { required }) => {
                    if (required) {
                        return (
                            <Flex>
                                {label}
                                {<span style={{ color: "red" }}>*</span>}
                            </Flex>)
                    } else {
                        return label
                    }
                }
                }
            >
                <Form.Item shouldUpdate  {...formItemLayout}>
                    {({ getFieldsValue, getFieldValue, setFieldValue }) => {
                        return (
                            <Row>
                                <Col span={24}>
                                    <FormInput required={true} name="reason" rows={4} type="textArea" />
                                </Col>
                            </Row>
                        )
                    }}
                </Form.Item>
            </FormAntd>
        </Modal>
    )

}

export default RejectReasonModal